import type { IntegrationCallOutcomeDto } from '@his/shared';
import { ApiError } from '@/lib/api';
import { describeError } from '@/lib/auth';
import { translateServerMessage } from '@/lib/i18n-core';

export interface ToastLike {
  success: (title: string, description?: string) => void;
  error: (title: string, description?: string) => void;
  warning: (title: string, description?: string) => void;
}

const DETAIL_CODES = new Set(['INTEGRATION_DATA_INCOMPLETE', 'INTEGRATION_NOT_CONFIGURED']);

export function describeIntegrationError(error: unknown): string {
  if (error instanceof ApiError && DETAIL_CODES.has(error.code) && error.details.length > 0) {
    const translated = (text: string) => translateServerMessage(text) ?? text;
    return `${translated(error.message)} ${error.details.map((detail) => translated(detail.message)).join(' · ')}`;
  }
  return describeError(error);
}

export function reportOutcome(toast: ToastLike, outcome: IntegrationCallOutcomeDto, doneTitle: string): void {
  if (outcome.status === 'succeeded') toast.success(doneTitle, outcome.message);
  else if (outcome.queued) toast.warning('Saved for later', outcome.message);
  else toast.error(outcome.offline ? 'No internet connection' : 'Could not complete it', outcome.message);
}
